// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__7u0D_","productName":"Table_productName__2ZtjL"};